import React from "react";
import showIcon from "../../../../../assets/design-revamp-company/company-detail-headers/icon-show-table.svg";
import hideIcon from "../../../../../assets/design-revamp-company/company-detail-headers/icon-hide-table.svg";
import { LovableAwareShowHide } from "../../../../NewProductCategories/ProductDetailsLCA/components/LovableFlowControls";

export const ShowHideTable = ({ showTable, setShowTable }) => {
  return (
    <LovableAwareShowHide
      isOpen={showTable}
      onToggle={() => setShowTable(!showTable)}
      legacyShowSrc={showIcon}
      legacyHideSrc={hideIcon}
      size="md"
      imgClassName="show-hide-table-icon"
    />
  );
};
